const knowMoreEl = document.getElementById('know-more');
const currentPrice = document.getElementById('current-price');
const stockPrice = document.getElementById('stock-price');
const stockPercent = document.getElementById('stock-percent');
const close = document.getElementById(`stock-summary-Close`);
const open = document.getElementById(`stock-summary-Open`);
const high = document.getElementById(`stock-summary-High`);
const low = document.getElementById(`stock-summary-Low`);
const volume = document.getElementById(`stock-summary-Volume`);
const turnOver = document.getElementById(`stock-summary-Net Turnover (in Cr)`);
const high52 = document.getElementById(`stock-summary-52Wk High`);
const low52 = document.getElementById(`stock-summary-52Wk Low`);
const webDate = document.getElementById(`web-date`);
const mobDate = document.getElementById(`date-mob`);
const nseBtn = document.getElementById('nse-btn');
const isNse = nseBtn?.classList.contains('active') || false;
let currentPath = window.location.pathname.split('/').filter(Boolean);
let exchange = isNse ? 'NSE' : 'BSE';
const companyName =
  currentPath.length > 1 ? currentPath[1].split('-share-price')[0] : null;

function formatCurrency(amount) {
  if (amount === null || amount === undefined || amount === 0) {
    return null;
  }
  const formattedPrice = new Intl.NumberFormat('en-IN', {
    style: 'decimal',
    currency: 'INR',
    minimumFractionDigits: 2,
  }).format(amount);
  let [integerPart, decimalPart] = amount.toFixed(2).split('.');
  integerPart = new Intl.NumberFormat('en-IN').format(Number(integerPart));
  return {
    formattedPrice,
    integerPart,
    decimalPart,
  };
}

function getLastUpdated() {
  const now = new Date();

  // Convert time to IST (India Standard Time) and subtract 2 minutes
  now.setMinutes(now.getMinutes() + (5 * 60 + 30 - 2)); // Add 5 hours 30 minutes, then subtract 2 minutes

  return (
    new Intl.DateTimeFormat('en-IN', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'Asia/Kolkata',
    })
      .format(now)
      .replace(',', ' at') + ' IST'
  );
}
if (webDate) {
  webDate.innerHTML = `As on ${getLastUpdated()}`;
}
if (mobDate) {
  mobDate.innerHTML = `As on ${getLastUpdated()}`;
}

if (companyName) {
  get_stock_data(companyName).then((response) => {
    const priceData = response.price[exchange];
    if (priceData && stockPrice && stockPercent) {
      const CPrice = formatCurrency(priceData.close);
      currentPrice.innerHTML = CPrice.formattedPrice;
      stockPrice.innerHTML =
        priceData.diff < 0
          ? priceData.diff.toFixed(2)
          : `+${priceData.diff.toFixed(2)}`;
      stockPercent.innerHTML =
        priceData.changePer < 0
          ? `(${priceData.changePer.toFixed(2)}%)`
          : `(+${priceData.changePer.toFixed(2)}%)`;
      if (priceData.diff < 0) {
        stockPrice.classList.add('negative-value');
        stockPercent.classList.add('negative-value');
      }
    }
    if (response.cocode) {
      updateSummary(response.cocode);
    }
  });
}

function updateValue(element, elementContent) {
  if (elementContent == '-') {
    element.innerHTML = '-';
  } else {
    element.innerHTML = `₹${elementContent.integerPart}.<span class="decimal-part">${elementContent.decimalPart}</span>`;
  }
}

function updateSummary(stockCocode) {
  fetch(
    `${window._Torus.BFF_BASE_URL}/stocks/${stockCocode}/${exchange.toLowerCase()}`,
  )
    .then((response) => response.json())
    .then((data) => {
      const stockSummary = data.stockSummary?.[exchange.toLowerCase()];
      let openContent = formatCurrency(stockSummary.open) ?? '-';
      updateValue(open, openContent);
      let closedContent = formatCurrency(stockSummary.close) ?? '-';
      updateValue(close, closedContent);
      let highContent = formatCurrency(stockSummary.high) ?? '-';
      updateValue(high, highContent);
      let lowContent = formatCurrency(stockSummary.low) ?? '-';
      updateValue(low, lowContent);
      let volumeContent = formatCurrency(stockSummary.volume) ?? '-';
      volume.innerHTML = volumeContent.integerPart;
      let turnOverContent =
        formatCurrency(stockSummary.netTurnOver / 10000000) ?? '-';
      updateValue(turnOver, turnOverContent);
      let high52Content = formatCurrency(stockSummary.fiftyTwoWeekHigh) ?? '-';
      updateValue(high52, high52Content);
      let low52Content = formatCurrency(stockSummary.fiftyTwoWeekLow) ?? '-';
      updateValue(low52, low52Content);
    })
    .catch((error) => console.error('Error fetching stock data:', error));
}

async function get_stock_data(companyName) {
  try {
    const response = await fetch(
      `${window._Torus.BFF_BASE_URL}/stocks/${companyName}`,
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching data from url : ${url}`, error);
    return null;
  }
}

if (knowMoreEl) {
  knowMoreEl.addEventListener('click', function (event) {
    event.preventDefault();
    var faqContent = document.getElementById('faq_answer').innerHTML;
    document.getElementById('modal-faq-answer').innerHTML = faqContent;
    document.getElementById('modal-overlay').style.display = 'block';
  });
}

const closeInfoEl = document.getElementById('back-button');

if (closeInfoEl) {
  closeInfoEl.addEventListener('click', function (event) {
    event.preventDefault();
    document.getElementById('modal-overlay').style.display = 'none';
  });
}
